<mwl-calendar-day-view
  [viewDate]="this.viewDate()"
  [events]="this.events()"
  [dayStartHour]="7"
  [dayEndHour]="19"
  [eventTemplate]="this.eventTemplate()"
  [refresh]="this.refresh()"
  [hourSegmentHeight]="this.hourSegmentHeight()"
>
</mwl-calendar-day-view>
